import { useCallback } from 'react';
import { useSelector } from 'react-redux';

const useFeatureFlags = () => {
    const { features_flags, areFeatureFlagsLoaded } = useSelector(state => ({
        features_flags: state.featuresFlags.features_flags,
        areFeatureFlagsLoaded: state.featuresFlags.features_flags_loaded,
    }))

    const isFeatureFlagActive = useCallback((flag_name) => {
        return (features_flags.find(
            ff => ff.key === flag_name
        )?.state === "on")
    }, [features_flags])

    return [isFeatureFlagActive, areFeatureFlagsLoaded];
}

export default useFeatureFlags;
